export enum CartActiveFeatures {
  CHECKOUT_ON_DIRECT_TO_CUSTOMER = "CheckoutOnDirectToCustomer",
  CHECKOUT_ON_EXISTING_CREDIT_LINE = "CheckoutOnExistingCreditLine", // Monarch
  CHECKOUT_ON_FINANCE_CONSENT = "CheckoutOnFinanceConsent", // Pacman
  CHECKOUT_ON_NEW_CREDIT_LINE = "CheckoutOnNewCreditLine",
  CHECKOUT_ON_PERSON_MANAGEMENT = "CheckoutOnPersonManagement",
  CHECKOUT_ON_SIMULTANEOUS_LOAN_LINE = "CheckoutOnSimultaneousLoanLine", // Super Pacman
  JOINT_LOAN_AND_EXISTING_LINE = "JointLoanAndExistingLine", // Super Monarch
  CONTRACT_ON_PHONE = "ContractOnPhone",
  M3_UGLY_AS_SMILE = "M3UglyAsSmile",
  RENTAL_MODEL = "RentalModel",
  SUBSCRIPTION_MODEL = "SubscriptionModel",
  CHECKOUT_ON_KYC_REUSE = "CheckoutOnKycReuse",
  SKIPPED_KYC = "SkippedKyc",
  CONFIGURABLE_M3 = "ConfigurableM3",
}
